import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const DATE_FORMAT_DEFAULT = 'DD/MM/YYYY';
const DATE_FORMAT_ISO = 'YYYY-MM-DDTHH:mm:ss';
const DATE_FORMAT_ISO_ODATA = 'YYYY-MM-DDTHH:mm:ss.SSS[Z]';

export const dateToday = () => moment();

// Dates format
export const dateToString = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val).format(format) : '';

export const stringToDate = (val, format = DATE_FORMAT_DEFAULT) => moment(val, format);

export const dateToISO = (val, format = DATE_FORMAT_DEFAULT) =>
  val ? moment(val, format).format(DATE_FORMAT_ISO) : '';

export const dateToISOAddMonths = (val, months) =>
  val
    ? moment(val)
      .add(months, 'M')
      .format(DATE_FORMAT_ISO)
    : '';

const adjustTimeIsYesterday = (value, format) => {
  const inputDate = moment(value, format);
  const yesterday = moment()
    .subtract(1, 'days')
    .startOf('day');

  if (inputDate.isSame(yesterday, 'day')) {
    inputDate.endOf('day');
  }

  return inputDate;
};

export const dateToISOOData = (val, format = DATE_FORMAT_ISO_ODATA) =>
  val ? adjustTimeIsYesterday(val, format).format(DATE_FORMAT_ISO_ODATA) : '';

export const dateToISOAddDays = (val, days) =>
  val
    ? moment(val)
      .add(days, 'd')
      .format(DATE_FORMAT_ISO)
    : '';

export const isValidDate = val =>
  // eslint-disable-next-line no-underscore-dangle
  moment(val, DATE_FORMAT_DEFAULT, true)._isValid;

export const isDateFormatted = val =>
  // eslint-disable-next-line no-underscore-dangle
  moment(val, DATE_FORMAT_DEFAULT, true)._isValid;
